import { UserContactData } from '.';

export interface ShipperGeneratedCounterOffer {
  carrierUser: UserContactData;
  scac: string;
  postTabLineHaul: number;
  postTabFuel: number;
  contractedCarrierLineHaul: number;
}
